import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import { Footer } from "../Footer";
import { useCookies } from 'react-cookie';
import { Box, Fab, TextField, Typography } from "@mui/material";
import React, { useRef, useState } from "react";
import { InstitucionalPalette, themePalette } from "../../config/theme.config";
import { FaAngleLeft, FaAngleRight, FaClipboardList, FaHandPointUp, FaHome, FaIdCard } from "react-icons/fa";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import AccountService from "../../services/AccountService";
import { inUser, outUser } from "../../redux/slices/auth.slice";
import { useDispatch, useSelector } from "react-redux";
import { decodeToken } from "../../utils/jwtUtils";
import { RootState } from "../../redux/store";
import { LoadingScreen } from "../Jester/LoadingScreen";
import { SetLoggedUser } from "../../types/Usuario/LoggedUser";
import { HeaderLogIn } from "../HeaderLogIn";
import { LayoutProps } from "../../types/Layout/Layout";
import { SidebarIcons } from "./SideBarIcons";
import { motion } from "framer-motion";

export const LayoutAuth: React.FC<LayoutProps> = ({ children, isAuth = false, userRoles = [] }) => {
    const [cookies, setCookie] = useCookies(["tokenEspolAds"]);
    const dispatch = useDispatch();
    const { accounts } = useMsal();
    const { instance } = useMsal();
    const user = useSelector((state: RootState) => state.authReducer.userData);
    const [isDrawerOpen, setIsDrawerOpen] = useState(true);
    const [width, setWidth] = useState("10vw");
    const [imageSrc, setImageSrc] = useState<string>('');
    const headerRef = useRef<HTMLDivElement>(null);
    const [headerHeight, setHeaderHeight] = useState(0);
    const [loading, setLoading] = useState(true);
    const [testUserName, setTestUserName] = useState<string>('');
    const [isTestLogin, setIsTestLogin] = useState(false);
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const sidebarWidth = 180;
    const collapsedWidth = 40;
    const toggleSidebar = () => setSidebarOpen((prev) => !prev);

    const isAuthenticated = useIsAuthenticated();

    const toggleDrawer = () => {
        setIsDrawerOpen(!isDrawerOpen);
    };

    const handleScrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    async function GetUser(usuario: string) {
        await AccountService.LoginEspolAds(usuario)
            .then((data) => {
                //console.log(data)
                var person = SetLoggedUser(data);
                dispatch(inUser({
                    userData: person,
                    token: data.token,
                    isAuth: true,
                    isLoading: false
                })); // Guarda en Redux
                // if (person.foto) {
                //     saveImageToDB('profile-pic', person.foto);
                // }
                setCookie("tokenEspolAds", data.token, { path: "/", secure: false, sameSite: "strict" });
            }).catch((error) => {
                console.error(error)
            })
            .finally(() => {
                setTimeout(() => {
                    setLoading(false);
                }, 2000);;
            });
    }

    const logout = () => {
        setCookie("tokenEspolAds", "", { path: "/", expires: new Date(0) });
        dispatch(outUser());
        instance.logoutRedirect({
            postLogoutRedirectUri: "/",
        });
    }

    React.useEffect(() => {
        if (!isAuthenticated || accounts.length === 0) {
            console.warn("Usuario no autenticado");
            setLoading(false);
            return;
        }

        const token = cookies.tokenEspolAds;
        if (!token) {
            // Si no hay token, pero sí cuentas, obtener usuario por accounts
            if (accounts[0]?.username) {
                GetUser(accounts[0].username.split('@')[0]);
            }
            setLoading(false);
            return;
        }

        const decodedToken = decodeToken(token);
        //console.log(decodedToken)
        dispatch(inUser({
            userData: SetLoggedUser(decodedToken, token),
            token,
            isAuth: true,
            isLoading: false
        }));

        if (decodedToken?.exp) {
            const expTime = decodedToken.exp * 1000;
            const timeUntilExpiration = expTime - Date.now();
            if (timeUntilExpiration > 0) {
                setTimeout(() => {
                    console.warn("Token Expirado");
                    logout();
                }, timeUntilExpiration);
            } else {
                logout();
            }
        } else if (accounts[0]?.username) {
            GetUser(accounts[0].username.split('@')[0]);
        }

        setLoading(false);
    }, [isAuthenticated, accounts, cookies.tokenEspolAds]);

    React.useLayoutEffect(() => {
        const measureHeader = () => {
            if (headerRef.current) {
                setHeaderHeight(headerRef.current.clientHeight);
            }
        };

        // Medición inicial
        measureHeader();

        // Recalcular si cambia el tamaño de la ventana
        window.addEventListener("resize", measureHeader);
        return () => window.removeEventListener("resize", measureHeader);
    }, [user]);

    //if (!isAuthenticated && !cookies.tokenEspolAds) return <Navigate to="/" />;

    //Quitar en producción
    // React.useEffect(() => {
    //     if(cookies.tokenEspolAds && testUserName !== ''){
    //         window.location.reload();
    //     }        
    // },[cookies.tokenEspolAds]);
    
    if (!cookies.tokenEspolAds && isTestLogin) {
        return (
            <Box
                sx={{
                    height: "100vh",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                    gap: 2,
                    backgroundColor: "#f5f5f5",
                }}
            >
                <Typography variant="h6">Login de prueba</Typography>
                <Box display="flex" alignItems="center" gap={1}>
                    <TextField
                        label="Usuario"
                        placeholder="Ingrese usuario"
                        variant="outlined"
                        value={testUserName}
                        onChange={(e) => setTestUserName(e.target.value)}
                        sx={{ flex: 1 }}
                    />
                    <Typography variant="body1">@espol.edu.ec</Typography>
                </Box>
                <button
                    onClick={async () => {
                        setLoading(true);
                        try {
                            await GetUser(testUserName);
                        } catch (e) {
                            console.error("Login de prueba falló:", e);

                        } finally {
                            setLoading(false);
                        }
                    }}
                    disabled={!testUserName}
                    style={{ padding: "10px 20px", cursor: "pointer" }}
                >
                    Ingresar
                </button>
            </Box>
        );
    }

    if (loading) {
        return (
            <LoadingScreen />
        );
    }

    return (
        <Box sx={{ minHeight: '100vh' }}>
            <Box ref={headerRef}
                sx={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    zIndex: 1100,
                    borderBottom: `2px solid ${themePalette.NAVCOLOR}`,
                }}
            >
                <HeaderLogIn user={user} foto={imageSrc} isTest={isTestLogin} />
            </Box>
            <motion.div
                animate={{ width: sidebarOpen ? sidebarWidth : collapsedWidth }}
                transition={{ duration: 0.3 }}
                style={{
                    position: "fixed",
                    top: headerHeight, // altura del header
                    left: 0,
                    bottom: 0,
                    background: InstitucionalPalette.PRIMARY,
                    borderRight: "1px solid #ddd",
                    borderTopRightRadius: "16px",
                    borderBottomRightRadius: "16px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    overflow: "hidden",
                    zIndex: 1200,
                }}
            >
                {sidebarOpen && (
                    <Box sx={{ p: 2 }}>
                        <SidebarIcons isAuth={user.usuario.length > 0} userRoles={user.roles} />
                    </Box>
                )}
            </motion.div>
            <Box
                sx={{
                    position: "fixed",
                    top: "50%",
                    left: sidebarOpen ? sidebarWidth - 15 : collapsedWidth - 15,
                    transform: "translateY(-50%)",
                    bgcolor: "primary.main",
                    color: "white",
                    width: 30,
                    height: 30,
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    boxShadow: 2,
                    zIndex: 1301,
                }}
                onClick={toggleSidebar}
            >
                {sidebarOpen ? <FaAngleLeft /> : <FaAngleRight />}
            </Box>
            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    mt: 15,
                    mb: 5,
                    width: 'auto',
                    ml: isDrawerOpen ? `${width}px` : '0',
                    transition: 'margin-left 0.3s',
                }}
            >
                {children}
                <Footer />
            </Box>
            <Fab
                color="primary"
                size="small"
                onClick={handleScrollToTop}
                sx={{
                    position: 'fixed',
                    bottom: 16,
                    right: 16,
                    zIndex: 1200,
                }}
            >
                <FaHandPointUp />
            </Fab>
        </Box>
    );
};

